export { paginaEstilos } from './estilos.js';
export { paginaClientes } from './clientes.js';
export { paginaArticulos } from './partes.js';
export { paginamntoUsuario } from './mntoUsers.js';
export { paginadatosProd } from './datosProd.js';
export { paginadatosOts } from './datosOts.js';
export { paginaMntoOpciones } from './mntoOpciones.js';
export { paginaPtmstr } from './ptmstr.js';
export { paginaEstPartes } from './est_partes.js';
export { paginaNomina } from './nomina.js';
export { paginaMntoCasa } from './mntoCasa.js';
export { paginaContabilidad } from './contabilidad.js';
